import * as React from 'react';
import { IBannerWpProps } from './IBannerWpProps';
import * as strings from 'bannerWpStrings';
import * as pnp from 'sp-pnp-js';
import { ISPImage } from '../ISPImage';
import Carousel from '../Carousel/Carousel';
import Default from '../Default/Default';

export interface IBannerState {
  imgs: ISPImage[];
  listId: string;
  hasImages: boolean;
}
export interface IGalleryState {
  bullets: boolean;
  thumpnails: boolean;
  scroll: number;
}

export default class BannerWp extends React.Component<IBannerWpProps, IBannerState> {
  private lastId: string;
  private gallery: IGalleryState;

  constructor(props) {
    super(props);
    this.state = this._loadImagesURLFromSP(this.props.imgListId);
    this.lastId = '';
    this.gallery = {
      bullets: this.props.showBulletButtons,
      scroll: this.props.scrollSpeed,
      thumpnails: this.props.showThumpnails
    };
  }
  /**
   * Renders the react component. 
   * Default component - If there is no list selected or images on the selected list.
   * Carousel component -  If there are images on the selected list.
   * 
   */
  public render() {
    debugger;

    if (this.state.hasImages) {
      return (
        <div>
          <Carousel
            title={this.props.title}
            images={this.state.imgs}
            scrollSpeed={this.props.scrollSpeed * 5000}
            showBulletButtons={this.props.showBulletButtons}
            showThumpnails={this.props.showThumpnails}
            listId={this.state.listId}
          />
        </div>
      );
    }
    return (
      <Default message={strings.WPDefaultDescription} />
    );
  }

  /**
   * Is called after a property change. Verifies if it is necessary to update the state and acts accordingly.
   * @param nextProps new properties passed down from the Property Pane.
   */
  public componentWillReceiveProps(nextProps: IBannerWpProps) {
    debugger;
    if(this.state.listId !== nextProps.imgListId){
      this.lastId = this.state.listId;
      this._loadImagesURLFromSP(nextProps.imgListId);
    }
  }


  /**
   * Uses Sharepoint API to retrieve the items from a specific list and updates the state of the component.
   * @param listId the id of the list from which to retrieve the items.
   */
  private _loadImagesURLFromSP(listId: string): IBannerState {
    let state: IBannerState = {
      hasImages: false,
      imgs: [],
      listId: listId
    };
    if (listId != null) {
      pnp.sp.web.lists.getById(listId).items.filter('Ativo eq 1').get().then(
        (items: any[]) => this._processImages(items, state.imgs))
        .then(() => {
          pnp.sp.web.lists.getById(listId).items.filter('Ativo eq 1').select('EncodedAbsUrl').get()
            .then((items: any[]) => {
              this._processUrls(items, state.imgs);
              if (state.imgs.length > 0)
                state.hasImages = true;
              this.setState(state);
            });
        });
    }
    return state;
  }

  /**
   * Receives the response from an Sharepoint API request and processes it into an ISPImage array.
   * @param items the response with from the SharePoint API
   * @param list to load the images onto.
   */
  private _processImages(items: any, list: ISPImage[]) {
    debugger;
    for (var i = 0; i < items.length; i++) {
      list.push({
        id: items[i].GUID,
        src: undefined,
        isAtive: items[i].Ativo,
        description: items[i].Title,
        url: items[i].Link.Url
      });
    }
  }

  /**
   * Receives the response from an Sharepoint API request and processes it adding ther URL of the images to an ISPImage array.
   * @param items the response with from the SharePoint API
   * @param list of images to load the urls onto.
   */
  private _processUrls(items: any, list: ISPImage[]) {
    for (var i = 0; i < items.length; i++) {
      list[i].src = items[i].EncodedAbsUrl;
    }
  }

  private _validateNextGallery(nextProps: IBannerWpProps): boolean {
    let nextGallery: IGalleryState = {
      bullets: nextProps.showBulletButtons,
      scroll: nextProps.scrollSpeed,
      thumpnails: nextProps.showThumpnails
    };
    return nextGallery != this.gallery;
  }
}



// WEBPACK FOOTER //
// ../../../../../src/webparts/bannerWp/components/BannerWp/BannerWp.tsx